import { ImageCampaign } from 'ui/components';

export const ImageCampaignFeature: React.FC<Content.ImageCampaign> = ({ content, settings }) => {
    return (
		<ImageCampaign {...content?.properties} {...settings?.properties}  />
)};
